import { useMemo } from 'react';
import { useResolvedPath } from 'react-router-dom';

import { ITabItem, Tabs } from '../../../components/tabs/Tabs';
import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { useTranslation } from '../../../contexts/translation-context';
import { PageHeading } from 'components/PageHeading';

export const CarrierPortalInfoWrapper = () => {
  const { i18n } = useTranslation();
  const generalRoute = useResolvedPath('info');
  const contactsRoute = useResolvedPath('contacts');
  const trucksRoute = useResolvedPath('trucks');
  const tabItems = useMemo<ITabItem[]>(() => {
    const res = [
      {
        title: i18n('carrierPortal.businessInformation.tabGeneral'),
        path: generalRoute.pathname,
      },
      {
        title: i18n('carrierPortal.businessInformation.tabFleet'),
        path: trucksRoute.pathname,
      },
      {
        title: i18n('carrierPortal.businessInformation.tabContacts'),
        path: contactsRoute.pathname,
      },
    ];

    return res;
  }, []);

  return (
    <div>
      <PageHeader title={i18n('customerPortal.businessInformation.updateBusinessInformation')} />

      <PageHeading
        leftSide={<Breadcrumb currentItem={i18n('customerPortal.businessInformation.businessInformation')} />}
      />

      <div className="px-4">
        <Tabs items={tabItems} />
      </div>
    </div>
  );
};
